import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { setPageTitle } from '../../redux/slice/pageTitleSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import AddSeller from './AddSeller'
import {
  allCrudNames,
  allPages,
  checkPageAccess
} from '../../../lib/AllPageNames'
import NotFound from '../../NotFound/NotFound'
import GSTInfo from './GSTInfo'
import WarehouseModal from './WarehouseModal'
import { useImmer } from 'use-immer'
import Loader from '../../../components/Loader'
import CustomToast from '../../../components/Toast/CustomToast'
import { isInventoryModel } from '../../../lib/AllStaticVariables'

const ManageSeller = () => {
  const [activeToggle, setActiveToggle] = useState(
    isInventoryModel ? 'gst' : 'seller'
  )
  const { pageAccess, sellerDetails } = useSelector((state) => state.user)
  const dispatch = useDispatch()

  const initValues = {
    gstInfo: {
      userID: sellerDetails?.userID,
      gstNo: '',
      legalName: '',
      tradeName: '',
      gstType: '',
      gstDoc: '',
      registeredAddressLine1: '',
      registeredAddressLine2: '',
      registeredLandmark: '',
      registeredPincode: '',
      registeredStateId: '',
      registeredCityId: '',
      registeredCountryId: '',
      tcsNo: '',
      status: '',
      isHeadOffice: true
    },
    warehouse: {
      userID: sellerDetails?.userID,
      gstInfoId: null,
      name: '',
      contactPersonName: '',
      contactPersonMobileNo: '',
      addressLine1: '',
      addressLine2: '',
      landmark: '',
      pincode: '',
      countryId: '',
      stateId: '',
      cityId: '',
      status: ''
    }
  }
  const [initialValues, setInitialValues] = useState(initValues)
  const [loading, setLoading] = useState(false)
  const [toast, setToast] = useState({
    show: false,
    text: null,
    variation: null
  })
  const [modalShow, setModalShow] = useImmer({
    createSeller: false,
    basicInfo: false,
    gstInfo: false,
    warehouse: false,
    report: false,
    gstReport: false
  })

  useEffect(() => {
    dispatch(
      setPageTitle(isInventoryModel ? 'Manage Warehouse' : 'Manage Seller')
    )
  }, [])

  return checkPageAccess(
    pageAccess,
    allPages?.manageSeller,
    allCrudNames?.read
  ) ? (
    <>
      {checkPageAccess(
        pageAccess,
        allPages?.manageSeller,
        allCrudNames?.read
      ) &&
        !isInventoryModel && (
          <div className='card'>
            <div className='card-body p-0'>
              <div className='nav-tabs-horizontal nav nav-tabs'>
                <Link
                  onClick={() => setActiveToggle('seller')}
                  data-toggle='tab'
                  className={`nav-link fw-semibold ${
                    activeToggle === 'seller' ? 'active show' : ''
                  }`}
                >
                  <span className='nav-span'>
                    Seller
                    <hr />
                  </span>
                </Link>
              </div>

              <div className='tab-content p-3'>
                <div
                  id='seller'
                  className={`tab-pane fade ${
                    activeToggle === 'seller' ? 'active show' : ''
                  }`}
                >
                  {activeToggle === 'seller' && (
                    <AddSeller activeToggle={activeToggle} />
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

      {checkPageAccess(
        pageAccess,
        allPages?.manageSeller,
        allCrudNames?.read
      ) &&
        isInventoryModel && (
          <div className='card'>
            <div className='card-body p-0'>
              <div className='nav-tabs-horizontal nav nav-tabs'>
                <Link
                  onClick={() => setActiveToggle('gst')}
                  data-toggle='tab'
                  className={`nav-link fw-semibold ${
                    activeToggle === 'gst' ? 'active show' : ''
                  }`}
                >
                  <span className='nav-span'>
                    Manage GST
                    <hr />
                  </span>
                </Link>
                <Link
                  onClick={() => setActiveToggle('warehouse')}
                  data-toggle='tab'
                  className={`nav-link fw-semibold ${
                    activeToggle === 'warehouse' ? 'active show' : ''
                  }`}
                >
                  <span className='nav-span'>
                    Manage Warehouse
                    <hr />
                  </span>
                </Link>
              </div>

              <div className='tab-content p-3'>
                <div
                  id='gst'
                  className={`tab-pane fade ${
                    activeToggle === 'gst' ? 'active show' : ''
                  }`}
                >
                  {activeToggle === 'gst' && (
                    <GSTInfo
                      initValues={initValues}
                      initialValues={initialValues}
                      setInitialValues={setInitialValues}
                      loading={loading}
                      setLoading={setLoading}
                      toast={toast}
                      setToast={setToast}
                      isModalRequired={false}
                      modalShow={modalShow}
                      setModalShow={setModalShow}
                    />
                  )}
                </div>
                <div
                  id='warehouse'
                  className={`tab-pane fade ${
                    activeToggle === 'warehouse' ? 'active show' : ''
                  }`}
                >
                  {activeToggle === 'warehouse' && (
                    <WarehouseModal
                      initValues={initValues}
                      initialValues={initialValues}
                      setInitialValues={setInitialValues}
                      loading={loading}
                      setLoading={setLoading}
                      toast={toast}
                      setToast={setToast}
                      isModalRequired={false}
                      modalShow={modalShow}
                      setModalShow={setModalShow}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

      {toast?.show && (
        <CustomToast text={toast?.text} variation={toast?.variation} />
      )}

      {loading && <Loader />}
    </>
  ) : (
    <NotFound />
  )
}

export default ManageSeller
